export var PulseUserType;
(function (PulseUserType) {
    PulseUserType["STANDARD"] = "STANDARD";
    PulseUserType["ADMIN"] = "ADMIN";
})(PulseUserType || (PulseUserType = {}));
export const SESSION_EXPIRED_MESSAGE = "Session expired. Please login again.";
export const SESSION_UNAUTHORIZED_MESSAGE = "Your session has expired because your access permissions have changed. Please log in again.";
